import ASTBlock from "../ASTBlock";
import Blockly from 'blockly';

export default class Start extends ASTBlock {
    constructor(color) {
        super(color, "start")
        this.predefinedInputs = {}
        this.TOP_LEVEL = true
    }

    addToBlockly() {
        var json = {
            "tooltip": "",
            "helpUrl": "",
            "message0": "Start des Programmes %1",
            "args0": [{
                "type": "input_dummy",
                "name": "NAME"
            }],
            "nextStatement": null,
            "inputsInline": false
        }

        let that = this
        Blockly.Blocks[this.name] = {
            init: function() {
                this.jsonInit(json);
                this.setColour(that.color)
            }

        }
    }
}